import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  CreateTaskInProjectTemplate,
  createTaskInProjectTemplate,
} from '../../actions';
import { createProjectTemplateTask } from '../../slices';
import { ProjectTemplateTask } from '../../types';

export function* createTemplateTaskWithParentProps(
  payload: CreateTaskInProjectTemplate,
): Generator {
  const task: AtLeast<ProjectTemplateTask, 'taskId'> = {
    taskId: floatUid(),
    ...payload.payload,
    isNew: true,
  };

  yield put(
    createProjectTemplateTask({
      task,
      projectPhaseId: payload.projectPhaseId,
    }),
  );
}

function* createTaskInTemplateSaga(
  action: StoreActionProps<CreateTaskInProjectTemplate>,
) {
  try {
    const { payload } = action;

    yield createTemplateTaskWithParentProps(payload);
  } catch (error) {
    logger.error('an error creating the task in template', { error });

    message.error('There was an error creating the task');
  }
}

export function* watchCreateTaskInTemplateSagaSaga(): Generator {
  yield takeLatest(createTaskInProjectTemplate.type, createTaskInTemplateSaga);
}
